import React, {Component} from "react";
import {Card, Form} from "react-bootstrap";
import "../Elements/FromGroup/form_select.css"
import AscModal from "../Elements/Modal/Modal";

export default class PartnerReadModal extends Component {

    render() {
        return (
            <AscModal
                state={this.props.state}
                propSetState={this.props.propSetState}
                modalClose={this.props.modalClose}
                langText={this.props.langText}
                validationHandle={this.props.validationHandle}
                onClick={this.props.onClick}
            >
                <Card variant="info">
                    <Card.Header>
                        <Card.Title>
                            {this.props.langText.Body.PartnerInfo}
                        </Card.Title>
                    </Card.Header>
                    <Card.Body>
                        <Form.Group className="mb-3">
                            <Form.Label>{this.props.langText.Body.PartnerId}</Form.Label>
                            <Form.Control type="text" value={this.props.state.hm12_id} disabled/>
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label>{this.props.langText.Body.PartnerName}</Form.Label>
                            <Form.Control type="text" value={this.props.state.name} disabled/>
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label>{this.props.langText.Body.PartnerS3BucketName}</Form.Label>
                            <Form.Control type="text" value={this.props.state.s3_bucket_name} disabled/>
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label>{this.props.langText.Body.PartnerDomain}</Form.Label>
                            <Form.Control type="text" value={this.props.state.domain} disabled/>
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label>{this.props.langText.Body.PartnerIdentifier}</Form.Label>
                            <Form.Control type="text" value={this.props.state.identifier} disabled/>
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label>{this.props.langText.Body.PartnerOptions}</Form.Label>
                            <Form.Control
                                as="textarea"
                                rows={5}
                                value={this.props.state.options}
                                disabled
                            />
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label>{this.props.langText.Body.PartnerCreated}</Form.Label>
                            <Form.Control type="text" value={this.props.state.created} disabled/>
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label>{this.props.langText.Body.PartnerModified}</Form.Label>
                            <Form.Control type="text" value={this.props.state.modified} disabled/>
                        </Form.Group>
                    </Card.Body>
                </Card>
            </AscModal>
        );
    }
}
